"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationsSummaryCards = InvitationsSummaryCards;
var jsx_runtime_1 = require("react/jsx-runtime");
var stat_tile_grid_1 = require("../stat-tile-grid");
function InvitationsSummaryCards(props) {
    var tiles = props.tiles;
    return (0, jsx_runtime_1.jsx)(stat_tile_grid_1.StatTileGrid, { tiles: tiles });
}
